import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AwpYesNoModal from '@components/Common/AwpYesNoModal';
import SystemNotificationCard from './SystemNotificationCard';
import { Button, Row, Col } from 'react-bootstrap';
import { FORM_MODE, REST_API } from '@awp/constants';
import { toast } from 'react-toastify';
import { DeleteJson, GetJson } from '@awp/helpers/fetchReact';
import Authorize from '@awp/components/Authorize';
import AwpValidationErrorModal from '@awp/components/Common/AwpValidationErrorModal';
import { Permissions } from '@awp/constants';
import { Crud } from '@awp/shared/Crud';

const SystemNotificationList = ({
  setData,
  data,
  loading,
  setMode,
  notificationMessageData,
  setNotificationMessageData,
}) => {
  const [showYesNoModal, setShowYesNoModal] = useState(false);
  const [entityErrors, setEntityErrors] = useState(null);
  const [showMore, setShowMore] = useState(true);
  const [isLastOne, setLastOne] = useState(false);

  const crud = new Crud('System Notifications');

  useEffect(() => {
    if (!isLastOne) {
      setShowMore(data.length >= 5);
    }
    if (!showYesNoModal) {
      setNotificationMessageData({});
    }
  }, [data, showYesNoModal]);

  const handleDelete = async () => {
    setShowYesNoModal(false);
    deleteSystemNotification();
  };

  const deleteSystemNotification = () => {
    const id = notificationMessageData.Id;
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGES + id;

    DeleteJson(url, {})
      .then(async (response) => {
        if (response.ok) {
          setNotificationMessageData({});
          removeData(id);
          toast.success('System Notification has been deleted');
          setMode(FORM_MODE.LIST);
        } else if (response.status === 412) {
          const errors = await response.json();
          if (errors.entity) setEntityErrors({ SystemNotification: errors.entity });
          toast.error('Error occurred while deleting');
        }
      })
      .finally(() => {
        setMode(FORM_MODE.LIST);
      });
  };

  const loadMore = () => {
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGES + data.length;

    GetJson(url)
      .then((response) => response.json())
      .then((newData) => {
        if (newData.length < 5) {
          setShowMore(false);
          setLastOne(true);
        }
        setData([...data, ...newData]);
      });
  };

  const removeData = (Id) => {
    let _data = [...data];
    let _removedData = [];
    _data.map((o) => {
      if (o.Id !== Id) {
        _removedData.push(o);
      }
    });
    setData([..._removedData]);
  };

  return (
    <>
      <div className="container mb-4">
        <Row style={{ marginBottom: '10px' }}>
          <Col sm={4}>
            <div className="d-flex">{crud.getHeader({ className: 'flex-grow-1' })}</div>
          </Col>
          <Col sm={3}>
            <Authorize requires={[Permissions.WriteSysNotification]}>
              <Button
                className="mr-2"
                variant="primary"
                onClick={() => {
                  setMode(FORM_MODE.CREATE);
                }}
                disabled={loading}
              >
                Create Notification
              </Button>
            </Authorize>
          </Col>
        </Row>
        <AwpValidationErrorModal setErrors={setEntityErrors} errors={entityErrors} />
        <Row>
          <Col style={{ maxWidth: '540px' }}>
            {data.map((data, index) => {
              return (
                <SystemNotificationCard
                  data={data}
                  setMode={setMode}
                  setNotificationMessageData={setNotificationMessageData}
                  setShowYesNoModal={setShowYesNoModal}
                  key={index}
                />
              );
            })}
          </Col>
        </Row>
        {showMore ? (
          <Row>
            <Col style={{ maxWidth: '540px' }}>
              <div className="d-flex justify-content-center">
                <Button
                  className="mr-2 my-3"
                  variant="outline-primary"
                  onClick={() => {
                    loadMore();
                  }}
                  disabled={loading}
                >
                  Load More Notifications
                </Button>
              </div>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </div>
      <AwpYesNoModal
        showYesNoModal={showYesNoModal}
        setShowYesNoModal={setShowYesNoModal}
        onClickYes={handleDelete}
        title="Delete System Notification"
        body={
          `Are you sure you want to delete the ${notificationMessageData?.Name || ''}` +
          `${notificationMessageData?.Name ? ' ' : ''}notification?`
        }
      />
    </>
  );
};

SystemNotificationList.propTypes = {
  setData: PropTypes.func,
  data: PropTypes.array,
  loading: PropTypes.bool,
  setMode: PropTypes.func,
  setNotificationMessageData: PropTypes.func,
};

export default SystemNotificationList;
